export function updateDesignMode(mode) {
    return {
        type: 'UPDATE_DESIGN_MODE',
        designMode: mode
    }
}
